import { ADMIN } from "@/constants/testIds";

export function StatCard({ icon, label, value, accent = false }) {
  return (
    <div
      data-testid={ADMIN.statCard}
      className={`rounded-2xl p-5 border ${accent ? "bg-amber-50 border-amber-200" : "bg-white border-slate-200"}`}
    >
      <div className={`inline-flex items-center gap-2 text-xs uppercase tracking-widest font-semibold ${accent ? "text-amber-800" : "text-slate-500"}`}>
        {icon} {label}
      </div>
      <div className={`mt-2 font-display font-black text-3xl ${accent ? "text-amber-900" : "text-slate-900"}`}>
        {value ?? "—"}
      </div>
    </div>
  );
}

export function DataTable({ columns, rows, rowTestId, empty, onRowClick }) {
  if (!rows.length) {
    return (
      <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center text-slate-500 text-sm">
        {empty}
      </div>
    );
  }
  return (
    <div className="bg-white border border-slate-200 rounded-2xl overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50/60">
            {columns.map((c) => (
              <th
                key={c.key}
                className="text-left px-4 py-3 text-[11px] uppercase tracking-widest text-slate-500 font-semibold whitespace-nowrap"
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr
              key={r.id || r.session_id || r.email}
              data-testid={rowTestId}
              onClick={onRowClick ? () => onRowClick(r) : undefined}
              className={`border-b border-slate-100 last:border-0 hover:bg-slate-50/50 ${onRowClick ? "cursor-pointer" : ""}`}
            >
              {columns.map((c) => (
                <td key={c.key} className="px-4 py-3 text-slate-800 align-top">
                  {c.render ? c.render(r) : r[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
